module.exports = __webpack_public_path__ + "static/media/img_panel_white_apts.69e5f437.jpg";